import type { ReactNode } from 'react';

import { ProjectName } from './ProjectName.tsx';

export function PageShell({
  children,
  projectName,
}: {
  children: ReactNode;
  projectName?: 'current' | 'link';
}) {
  return (
    <main className="mx-auto w-[min(48rem,calc(100%-2rem))] py-[clamp(1.5rem,5vw,4rem)] pb-16">
      {projectName === undefined ? null : (
        <ProjectName className="mb-4" isHome={projectName === 'current'} />
      )}
      {children}
    </main>
  );
}
